import PropTypes from 'prop-types';
import { css } from '@eti/styles';
import { vars } from '@etg/wings';
import { getBoundType } from '../trip-details/utils/format';
import { bounds as boundsPropTypes } from '../trip-details/propTypes';
import ItineraryBound from './ItineraryBound';

const boundsStyles = (shouldAddBorderToBound) => css`
  ${shouldAddBorderToBound &&
  `
  border: solid 1px ${vars.colors.divider};
  border-radius: 10px;
  margin-top: 10px;`}

  & > :nth-of-type(3) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

const ItineraryContent = ({
  bounds = [],
  isMultiStop,
  isOpen,
  shouldAddBorderToBound = false,
  shouldHideBaggageInfo,
  shouldShowTitle,
}) => {
  return (
    <>
      {bounds?.map((bound, index) => (
        <div
          className={boundsStyles(shouldAddBorderToBound)}
          data-testid={`tripDetails-bound-${bound.boundId}`}
          key={`boundInfo-${bound.boundId}`}
        >
          <ItineraryBound
            boundId={bound.boundId}
            isMultiStop={isMultiStop}
            isOpen={isOpen}
            segments={bound.segments}
            shouldHideBaggageInfo={shouldHideBaggageInfo}
            shouldShowTitle={shouldShowTitle}
            type={getBoundType(index)}
          />
        </div>
      ))}
    </>
  );
};

ItineraryContent.propTypes = {
  bounds: boundsPropTypes,
  isMultiStop: PropTypes.bool,
  isOpen: PropTypes.bool,
  shouldAddBorderToBound: PropTypes.bool,
  shouldHideBaggageInfo: PropTypes.bool,
  shouldShowTitle: PropTypes.bool,
};

export default ItineraryContent;
